module.exports = __webpack_public_path__ + "static/media/11n.ced52474.svg";